(function () {
  'use strict';

  let userData = null;

  function loadUserData() {
    try {
      const stored = localStorage.getItem('netwrck_user');
      if (stored) {
        userData = JSON.parse(stored);
        // Also set window.userData for subscribe dialog compatibility
        window.userData = userData.user || userData;
        updateAuthUI();
      }
    } catch (e) {
      console.warn('Failed to load user data:', e);
      localStorage.removeItem('netwrck_user');
    }
  }

  function saveUserData(data) {
    try {
      const logoutPending =
        window.__netwrckLogoutStartedAt ||
        window.__netwrckLogoutBlockSessionSave ||
        sessionStorage.getItem('netwrck_logout_pending') === '1';
      if (logoutPending) {
        return;
      }
      userData = data;
      localStorage.setItem('netwrck_user', JSON.stringify(data));
      // Also set window.userData for subscribe dialog compatibility
      window.userData = data.user || data;
      updateAuthUI();
    } catch (e) {
      console.warn('Failed to save user data:', e);
    }
  }

  function clearUserData() {
    userData = null;
    window.currentUser = null;
    window.userSecret = null;
    window.userData = null;
    localStorage.removeItem('netwrck_user');
    localStorage.removeItem('userData');
    localStorage.removeItem('userSecret');
    localStorage.removeItem('userIsSubscribed');
    localStorage.removeItem('userDataTimestamp');
    updateAuthUI();
  }

  function clearLogoutBlock() {
    window.__netwrckLogoutStartedAt = 0;
    window.__netwrckLogoutBlockSessionSave = false;
    try {
      sessionStorage.removeItem('netwrck_logout_pending');
    } catch { /* Error ignored */ }
  }

  function markLogoutPending() {
    window.__netwrckLogoutStartedAt = Date.now();
    window.__netwrckLogoutBlockSessionSave = true;
    try {
      sessionStorage.setItem('netwrck_logout_pending', '1');
    } catch { /* Error ignored */ }
  }

  function updateAuthUI() {
    const loginBtns = document.querySelectorAll('[data-auth="login"]');
    const logoutBtns = document.querySelectorAll('[data-auth="logout"]');
    const userDisplays = document.querySelectorAll('[data-user]');

    // Handle header-specific classes
    const headerLoginSignup = document.querySelectorAll('.header-login-signup');
    const headerLoginSignout = document.querySelectorAll(
      '.header-login-signout'
    );
    const headerSubscribe = document.querySelectorAll('.header-subscribe');
    const headerAccount = document.querySelectorAll('.header-account');

    if (userData) {
      // Hide login/signup elements
      loginBtns.forEach((btn) => (btn.style.display = 'none'));
      headerLoginSignup.forEach((el) => (el.style.display = 'none'));

      // Show logout/authenticated elements
      logoutBtns.forEach((btn) => (btn.style.display = 'inline-block'));
      headerLoginSignout.forEach((el) => (el.style.display = 'block'));
      headerAccount.forEach((el) => (el.style.display = 'block'));

      // Show/hide subscribe button based on subscription status
      const isSubscribed =
        userData.user?.is_subscribed || userData.is_subscribed || false;
      headerSubscribe.forEach((el) => {
        el.style.display = isSubscribed ? 'none' : 'block';
      });

      // Update user display elements
      userDisplays.forEach((el) => {
        const field = el.getAttribute('data-user');
        const userObj = userData.user || userData;
        if (userObj[field]) {
          el.textContent = userObj[field];
          el.style.display = 'inline-block';
        }
      });
    } else {
      // Show login/signup elements
      loginBtns.forEach((btn) => (btn.style.display = 'inline-block'));
      headerLoginSignup.forEach((el) => (el.style.display = 'block'));

      // Hide logout/authenticated elements
      logoutBtns.forEach((btn) => (btn.style.display = 'none'));
      headerLoginSignout.forEach((el) => (el.style.display = 'none'));
      headerSubscribe.forEach((el) => (el.style.display = 'none'));
      headerAccount.forEach((el) => (el.style.display = 'none'));
      userDisplays.forEach((el) => (el.style.display = 'none'));
    }
  }

  function handleSignup(e) {
    e.preventDefault();

    const email = document.getElementById('page-username').value;
    const password = document.getElementById('page-userpass').value;
    const errorEl = document.getElementById('signup-error');

    if (!email || !password) {
      errorEl.textContent = 'Please fill in all fields';
      return;
    }

    errorEl.textContent = '';
    if (window.thFunnel) window.thFunnel.authStarted('sign_up', 'password');

    fetch('/api/create-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    })
      .then(async (response) => {
        let data = null;
        try {
          data = await response.json();
        } catch { /* Error ignored */ }

        if (response.ok && (data?.success || data?.user)) {
          clearLogoutBlock();
          saveUserData(data.user || data);
          if (window.thFunnel) window.thFunnel.authCompleted('sign_up', 'password', data);
          window.location.href = '/';
          return;
        }

        // Extract a helpful error message from server JSON
        let message = 'Signup failed';
        let isUserExists = response.status === 409;
        if (data) {
          message =
            data.error ||
            data.message ||
            (Array.isArray(data.detail)
              ? data.detail.map((d) => d.msg || d.message).join(', ')
              : message);
          if (/already\s*exists|already\s*registered/i.test(message)) {
            isUserExists = true;
          }
        } else if (!response.ok && response.status === 409) {
          message = 'User already exists';
        }
        if (window.thFunnel) window.thFunnel.authFailed('sign_up', 'password', isUserExists ? 'exists' : 'http_' + response.status);

        // Show error visibly and mark fields invalid
        try {
          if (isUserExists) {
            const loginUrl = '/login?email=' + encodeURIComponent(email);
            errorEl.innerHTML = 'User already exists. <a href="' + loginUrl + '">Log in instead</a>';
          } else {
            errorEl.textContent = message;
          }
          errorEl.style.display = 'block';
          errorEl.style.visibility = 'visible';
          const emailField = document.getElementById('page-username');
          const passwordField = document.getElementById('page-userpass');
          if (emailField && emailField.parentElement) {
            emailField.parentElement.classList.add('is-invalid');
          }
          if (passwordField && passwordField.parentElement) {
            passwordField.parentElement.classList.add('is-invalid');
            // Clear and focus password for retry UX
            passwordField.value = '';
            passwordField.focus();
          }
        } catch { /* Error ignored */ }
      })
      .catch((error) => {
        console.error('Signup error:', error);
        if (window.thFunnel) window.thFunnel.authFailed('sign_up', 'password', 'network');
        errorEl.textContent = 'Network error. Please try again.';
        errorEl.style.display = 'block';
        errorEl.style.visibility = 'visible';
      });
  }

  function displayLoginError(message) {
    let errorEl = document.querySelector('.mdl-textfield__error');

    if (!errorEl) {
      const passwordField = document
        .querySelector('input[name="password"], input#page-password')
        ?.closest('.mdl-textfield');
      if (passwordField) {
        errorEl = document.createElement('p');
        errorEl.id = 'auth-error';
        errorEl.className = 'small-note mdl-textfield__error';
        errorEl.style.cssText =
          'color: #d50000; margin-top: 10px; display: block; font-size: 12px;';
        passwordField.parentNode.insertBefore(
          errorEl,
          passwordField.nextSibling
        );
      }
    }

    if (errorEl) {
      errorEl.id = 'auth-error';
      errorEl.textContent = message;
      errorEl.style.display = 'block';
      errorEl.style.color = '#d50000';

      const emailField = document.querySelector(
        'input[name="email"], input#page-email'
      );
      const passwordField = document.querySelector(
        'input[name="password"], input#page-password'
      );
      if (emailField) {
        emailField.parentElement.classList.add('is-invalid');
      }
      if (passwordField) {
        passwordField.parentElement.classList.add('is-invalid');
      }
    } else {
      alert(message);
    }
  }

  function clearLoginError() {
    const errorEl = document.querySelector('.mdl-textfield__error');
    if (errorEl) {
      errorEl.style.display = 'none';
    }
    const emailField = document.querySelector(
      'input[name="email"], input#page-email'
    );
    const passwordField = document.querySelector(
      'input[name="password"], input#page-password'
    );
    if (emailField) {
      emailField.parentElement.classList.remove('is-invalid');
    }
    if (passwordField) {
      passwordField.parentElement.classList.remove('is-invalid');
    }
  }

  function handleLogin(e) {
    e.preventDefault();

    const emailInput =
      document.getElementById('page-email') ||
      document.getElementById('ebank-page-email') ||
      document.querySelector('input[name="email"]');
    const passwordInput =
      document.getElementById('page-password') ||
      document.getElementById('ebank-page-password') ||
      document.querySelector('input[name="password"]');

    if (!emailInput || !passwordInput) {
      console.error('[SIGNUP] Could not find email or password input fields');
      return;
    }

    const email = emailInput.value;
    const password = passwordInput.value;

    if (!email || !password) {
      return;
    }

    clearLoginError();
    if (window.thFunnel) window.thFunnel.authStarted('sign_in', 'password');

    var nextInput = document.querySelector('input[name="next"]');
    var nextUrl = (nextInput && nextInput.value) || '/';

    fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password, next: nextUrl }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success || data.logged_in) {
          clearLogoutBlock();
          if (data.user_data) {
            saveUserData({ user: data.user_data });
          } else {
            saveUserData(data);
          }
          if (window.thFunnel) window.thFunnel.authCompleted('sign_in', 'password', data);
          var redirectTo = data.redirect || nextUrl || '/';
          window.location.href = redirectTo;
        } else {
          if (window.thFunnel) window.thFunnel.authFailed('sign_in', 'password', data.error_code || 'rejected');
          displayLoginError(
            data.error || 'Login failed. Please check your credentials.'
          );
        }
      })
      .catch((error) => {
        console.error('Login error:', error);
        if (window.thFunnel) window.thFunnel.authFailed('sign_in', 'password', 'network');
        displayLoginError('Network error. Please try again.');
      });
  }

  function handleLogout() {
    markLogoutPending();
    return fetch('/api/logout', { method: 'POST', credentials: 'include' })
      .then(() => {
        if (typeof window.trackEvent === 'function') {
          window.trackEvent('auth', 'sign_out', 'logout');
        }
        clearUserData();
        // Inline UI update: show login/signup, hide logout/account/subscribe
        try {
          const loginEls = document.querySelectorAll(
            '.header-login-signup, .login-link, .signup-link'
          );
          const logoutEls = document.querySelectorAll('.header-login-signout');
          const accountEls = document.querySelectorAll(
            '.header-account, .account-link'
          );
          const subscribeEls = document.querySelectorAll('.header-subscribe');

          loginEls.forEach((el) => (el.style.display = ''));
          logoutEls.forEach((el) => (el.style.display = 'none'));
          accountEls.forEach((el) => (el.style.display = 'none'));
          subscribeEls.forEach((el) => (el.style.display = 'none'));

          const loginDialog = document.getElementById('login-dialog');
          const signupDialog = document.getElementById('signup-dialog');
          if (loginDialog && loginDialog.open) loginDialog.close();
          if (signupDialog && signupDialog.open) signupDialog.close();
        } catch { /* Error ignored */ }
      })
      .catch((error) => {
        console.error('Logout error:', error);
        clearUserData();
      });
  }

  function checkSession() {
    const requestStartedAt = Date.now();

    // First check if userData is already populated by server
    if (
      window.userData &&
      window.userData.id &&
      !window.__netwrckLogoutStartedAt &&
      !window.__netwrckLogoutBlockSessionSave &&
      sessionStorage.getItem('netwrck_logout_pending') !== '1'
    ) {
      saveUserData({
        success: true,
        logged_in: true,
        user: window.userData,
        user_data: window.userData,
      });
      return;
    }

    (window.APIClient && window.APIClient.get ? window.APIClient.get('/api/current-user') : fetch('/api/current-user', { credentials: 'include' }))
      .then((response) => response.json())
      .then((data) => {
        if (
          (window.__netwrckLogoutStartedAt || 0) > requestStartedAt ||
          window.__netwrckLogoutStartedAt ||
          window.__netwrckLogoutBlockSessionSave ||
          sessionStorage.getItem('netwrck_logout_pending') === '1'
        ) {
          clearUserData();
          return;
        }
        if (data.logged_in && data.user) {
          // Save the user object properly
          saveUserData({
            success: true,
            logged_in: true,
            user: data.user,
            user_data: data.user,
          });
        } else if (data.logged_in === false) {
          clearUserData();
        } else {
          // Don't clear data on ambiguous response - might be network/server issue
        }
      })
      .catch((error) => {
        console.warn('Session check failed, not clearing userData:', error);
        // Don't clear userData on fetch failure - might be temporary network issue
      });
  }

  function init() {
    loadUserData();
    checkSession();

    const signupForm = document.querySelector('.signup-form');
    if (signupForm) {
      signupForm.addEventListener('submit', handleSignup);
    }

    // Ebank page signup: intercept native form to handle conflicts
    try {
      const isEbank = /ebank/i.test(window.location.hostname);
      const ebankSignupForm = document.querySelector('form[action="/signup"]');
      if (isEbank && ebankSignupForm) {
        ebankSignupForm.addEventListener('submit', async function (e) {
          e.preventDefault();
          const emailInput =
            document.getElementById('ebank-signup-email') ||
            document.querySelector('input[name="email"]');
          const passwordInput =
            document.getElementById('ebank-signup-password') ||
            document.querySelector('input[name="password"]');
          const errorEl =
            document.getElementById('signup-error') ||
            document.getElementById('api-error');

          const email = (emailInput && emailInput.value) || '';
          const password = (passwordInput && passwordInput.value) || '';
          if (!email || !password) {
            if (errorEl)
              errorEl.textContent = 'Please enter email and password';
            return;
          }

          try {
            const resp = await fetch('/api/create-user', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({ email, password }),
            });

            if (resp.ok) {
              const data = await resp.json();
              if (data && (data.success || data.user)) {
                clearLogoutBlock();
                saveUserData(data.user || data);
                window.location.href = '/';
                return;
              }
            }

            // Not ok or success=false
            let msg = 'Signup failed';
            try {
              const j = await resp.json();
              msg = j.error || j.message || msg;
            } catch { /* Error ignored */ }

            if (
              /already\s+exists|already\s+registered/i.test(msg) ||
              resp.status === 409
            ) {
              // Switch to login and prefill
              try {
                const loginDialog = document.getElementById('login-dialog');
                const loginEmail = document.getElementById('login-email');
                const loginPassword = document.getElementById('login-password');
                if (loginEmail) loginEmail.value = email;
                if (loginPassword) loginPassword.value = password;
                if (
                  loginDialog &&
                  typeof loginDialog.showModal === 'function'
                ) {
                  loginDialog.showModal();
                } else {
                  try {
                    sessionStorage.setItem('prefill_email', email);
                    sessionStorage.setItem('prefill_password', password);
                  } catch (e) {
                    if (typeof console !== 'undefined' && console.warn) {
                      console.warn(
                        '[SIGNUP] Prefill sessionStorage failed:',
                        e
                      );
                    }
                  }
                  window.location.href = '/login#modal';
                }
                return;
              } catch (switchErr) {
                // ignore and show error below
              }
            }

            if (errorEl) {
              errorEl.textContent = msg;
              errorEl.style.display = 'block';
            }
          } catch (err) {
            if (errorEl) {
              errorEl.textContent = 'Network error. Please try again.';
              errorEl.style.display = 'block';
            }
          }
        });
      }
    } catch (e) {
      // best-effort only, but surface for debugging
      if (typeof console !== 'undefined' && console.error) {
        console.error('[SIGNUP] Initialization error (best-effort):', e);
      }
    }

    const loginForm = document.querySelector('form[action="/login"]');
    if (loginForm) {
      const isEbankForm = document.getElementById('ebank-page-email') !== null;
      if (!isEbankForm) {
        loginForm.addEventListener('submit', handleLogin);
      }

      const emailInput =
        document.getElementById('page-email') ||
        document.querySelector('input[name="email"]');
      const passwordInput =
        document.getElementById('page-password') ||
        document.querySelector('input[name="password"]');

      if (emailInput) {
        emailInput.addEventListener('input', clearLoginError);
        emailInput.addEventListener('focus', clearLoginError);
      }
      if (passwordInput) {
        passwordInput.addEventListener('input', clearLoginError);
        passwordInput.addEventListener('focus', clearLoginError);
      }
    }

    document.addEventListener('click', function (e) {
      const t = e.target;
      if (
        t.matches('[data-auth="logout"]') ||
        t.id === 'log-out' ||
        (t.closest && t.closest('a[href$="/logout"]'))
      ) {
        e.preventDefault();
        handleLogout();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.isLoggedIn = () => !!userData;
  window.getCurrentUser = () => userData;
  window.initSignup = init;
  if (typeof window.signout !== 'function') {
    window.signout = function () {
      return handleLogout();
    };
  }
})();
